import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { LiveStage } from "../components/live/LiveStage";
import { formatApiError } from "../lib/api";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Heart, Link2, Video } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function SessionRoomPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const [s, setS] = useState(null);
  const [err, setErr] = useState(null);
  const [join, setJoin] = useState(null);
  const key = new URLSearchParams(window.location.search).get("key") || "";

  useEffect(() => {
    api.get(`/sessions/${id}`, { params: key ? { key } : {} }).then((r) => setS(r.data)).catch(() => setErr("Session not found or access denied."));
  }, [id, key]);
  async function enter() { try { const { data } = await api.post(`/sessions/${id}/rtc`, { key }); setJoin(data); } catch (e) { toast.error(formatApiError(e)); } }
  async function invite() {
    try { const { data } = await api.post(`/sessions/${id}/invite-link`); await navigator.clipboard.writeText(`${window.location.origin}/session/${id}?key=${data.key}`); toast.success("Invite link copied. Anyone with it can join (up to 6 on camera)."); }
    catch (e) { toast.error(formatApiError(e)); }
  }

  if (err) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        <div className="text-center"><p className="font-serif text-3xl mb-4">{err}</p><Link to="/dashboard/sessions" className="btn-gold">Back to sessions</Link></div>
      </div>
    );
  }
  if (!s) return null;
  const owner = user && (s.user_id === user.user_id || user.role === "admin");
  if (join) return <div className="fixed inset-0 z-50 bg-black" data-testid="session-room"><LiveStage zoom join={join} title={s.topic || "Your session"} onLeave={() => setJoin(null)} /></div>;
  return (
    <div data-testid="session-room" className="min-h-screen bg-[var(--ink)] text-white flex flex-col items-center justify-center gap-5 px-6 text-center">
      <Link to="/dashboard/sessions" className="absolute top-5 left-6 text-sm text-white/70 flex items-center gap-1"><ArrowLeft className="w-4 h-4" /> Sessions</Link>
      <Heart className="w-8 h-8 text-[var(--gold)]" />
      <p className="font-serif text-4xl">{s.topic || "Your session"}</p>
      <p className="text-sm text-white/60">{s.scheduled_at ? new Date(s.scheduled_at).toLocaleString() : ""} · up to 6 people on camera</p>
      <div className="flex flex-wrap gap-3 justify-center">
        <button onClick={enter} className="btn-gold" data-testid="session-join"><Video className="w-4 h-4" /> Join call</button>
        {owner && <button onClick={invite} className="btn-outline-gold" data-testid="session-invite-link"><Link2 className="w-4 h-4" /> Copy invite link</button>}
      </div>
    </div>
  );
}
